/* SI SE NECESITA ALGO MÁS SE PUEDE ESPECIFICAR EN ESTE OPBJETO */
export default {
	// eslint-disable-next-line no-undef
	URL_APP,
	// eslint-disable-next-line no-undef
	URL_API,
	// eslint-disable-next-line no-undef
	URL_AUTH,
	// eslint-disable-next-line no-undef
	AUTH_ACTIVE,
	// eslint-disable-next-line no-undef
	MONITOR_HUB,
	// eslint-disable-next-line no-undef
	GOOGLE_ANALYTICS
};
